import { addImposterToUrl } from 'Utils';
import { api } from './axios';

const baseURL = '/Contacts';

export interface IContacts {
  district: string;
  duty: string;
  email: string;
  fax: string;
  faxPrefix: string;
  formLink: string;
  name: string;
  userBranch: string;
  workPhone1: string;
  workPhone2: string;
  workPhonePrefix1: string;
  workPhonePrefix2: string;
}

export interface IDistrictInfo {
  address: string;
  arrivalInstructions: string;
  districtId: number;
  name: string;
  phone?: string;
  fax?: string;
  urlName: string;
}

export const getContacts = async () => {
  const contacts = await api.get<{
    contacts: IContacts[];
    districtInfo: IDistrictInfo;
  }>(addImposterToUrl(baseURL, true));
  if (contacts.data) return contacts.data;
};
